import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { msalInstance } from './msal-instance'

async function initializeMsalForRedirectFlow(): Promise<void> {
  if (!msalInstance || typeof window === 'undefined') {
    return;
  }

  await msalInstance.initialize();

  const redirectResult = await msalInstance.handleRedirectPromise();

  if (redirectResult?.account) {
    msalInstance.setActiveAccount(redirectResult.account);
    return;
  }

  const activeAccount = msalInstance.getActiveAccount();
  if (!activeAccount) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }
}

async function main() {
  try {
    await initializeMsalForRedirectFlow();
    await bootstrapApplication(AppComponent, appConfig)
  } catch (err) {
    console.error(err);
  }
}

main();
